// export const BASE_API_URL = 'http://206.189.102.175/api/v1/';
// export const BASE_URL = 'http://206.189.102.175';
// export const BASE_SOCKET_URL = 'http://206.189.102.175:3000';

// export const BASE_API_URL =  'http://localhost:3000/api/v1/';
export const BASE_API_URL =
  process.env.REACT_APP_BASE_API_URL ||
  'https://api-dev.dev.jidipi.com/api/v1/';
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'https://api-dev.dev.jidipi.com';
export const BASE_SOCKET_URL =
  process.env.REACT_APP_BASE_SOCKET_URL || 'https://api-dev.dev.jidipi.com';
// export const BASE_SOCKET_URL =   process.env.REACT_APP_BASE_SOCKET_URL || 'https://api.jidipi.com:3210';
export const CDN_URL =
  process.env.REACT_APP_CDN_URL ?? 'https://upload.jidipi.com';
export const DOCUMENT_URL =
  process.env.REACT_APP_DOCUMENT_URL ?? 'https://document.jidipi.com/';
export const PUBLIC_TOKEN = '_t1iqeSXhY8RM2GcIHFNoMEzKd0UspR7';
// Used to fetch https://editor.setka.io/api/v2/integration?token=TkLPC4Jw01UMrqNdgKInXYPsjUaXnYW1
export const TOKEN = 'TkLPC4Jw01UMrqNdgKInXYPsjUaXnYW1';

// Main editor file setup in public/index.html directly.
// export const EDITOR_JS_URL =
//   'https://ceditor.setka.io/editor/3.2.8-rc1/01/01/editor.v3.2.8-rc1.1658242063.min.js';
//
// // Editor interface styles
// export const EDITOR_CSS_URL =
//   'https://ceditor.setka.io/editor/3.2.8-rc1/01/01/editor.v3.2.8-rc1.1658242063.min.css';
//
// // Company styles
// export const COMPANY_CSS_URL =
//   'https://ceditor.setka.io/clients/Xs9xVInUxQHyhtJghPIu3egpgew1OFU6/css/3705_ninonin_limited_1_1251.min.css';

// Company metadata
// export const COMPANY_JSON_URL =
//   'https://ceditor.setka.io/clients/Xs9xVInUxQHyhtJghPIu3egpgew1OFU6/json/3705_ninonin_limited_1_1251.json';
// export const COMPANY_JSON_URL =
//   'https://upload.jidipi.com/temp/3705_ninonin_limited_1_1251.json';
export const COMPANY_JSON_URL = '/editor/editor.json';
export const BASE_DIRECTORY = '';
export const PARTNER_DOMAIN =
  process.env.REACT_APP_PARTNER_DOMAIN ?? 'https://partners.jidipi.com';

export const NO_COMPANIES = ['626a653a09a72d00087a7858'];

export const EDITOR_ROLE_ID = '604767ddd3e5effc55b61513';
export const MANGER_ROLE_ID = '603ddb8358c5c6279bc2ed9c';
